import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private currentLanguage = 'nl';
  private translate = inject(TranslateService);

  setCurrentLanguage(lang: string) {
    this.currentLanguage = lang;
    if (typeof document !== 'undefined') {
      document.documentElement.lang = lang;
    }

    this.translate.use(lang);
  }

  getCurrentLanguage(): string {
    return this.currentLanguage;
  }

  getDefaultLanguage() {
    return navigator.language?.split('-')[0] || (navigator as any).userLanguage?.split('-')[0];
  }
}
